// extracted by mini-css-extract-plugin
export var chip = "_4l-9";
export var chipLabel = "_4l-a";
export var close = "_4l-7";
export var closeIcon = "_4l-8";
export var error = "_4l-6";
export var infoTooltip = "_4l-2";
export var innerContainer = "_4l-1";
export var input = "_4l-b";
export var medium = "_4l-5";
export var outerContainer = "_4l-0";
export var small = "_4l-4";
export var xSmall = "_4l-3";